<template>
    <div class="loginWrapper">
        <v-card
            class="elevation-24 login-card-wrapper"
            dark
            shaped
        >
            <div class="content-wrapper d-flex justify-space-around align-center flex-column">
                <div class="logoBg">
                    <div class="whiteCross">
                        <img
                            src="./../../../assets/hmi-cross.png"
                            alt="HMI Logo"
                            fetchpriority="high"
                            decoding="async"
                            width="100vw"
                            height="100vh"
                        >
                    </div>
                </div>
                <div class="loginInputs d-flex justify-space-around align-center flex-column">
                    <div class="header">
                        <div key="member-portal-title">
                            <h2 class="font-weight-black">
                                HMI Admin
                            </h2>
                        </div>
                        <v-alert
                            v-model="errLogin.status"
                            dismissible
                            class="text-center"
                            transition="scale-transition"
                            :style="`position: absolute; z-index: 2; left: 0; right: 0; top: ${screen_width >= 599 && screen_width <= 790 ? '55px' : screen_width >= 290 && screen_width <= 457 ? '50px' : 'calc(20% - 10px)' }; margin: 0 10px; border-radius: 16px;`"
                            type="error"
                        >
                            {{ errLogin.message }}
                        </v-alert>
                        <!-- <h4 class="my-5 red--text">{{ loginData && loginData.state && loginData.status !== 200 ? loginData.state : '' }}</h4> -->
                    </div>
                    <v-form
                        ref="form"
                        v-model="valid"
                        lazy-validation
                        class="loginForm"
                        @submit.prevent="validate()"
                    >
                        <div class="textFields">
                            <v-text-field
                                v-model.trim="email"
                                dense
                                label="Email"
                                :rules="emailRules"
                                color="green"
                                outlined
                                :prepend-inner-icon="mdiEmailOutline"
                                autocomplete="nope"
                            />
                            <v-text-field
                                v-model.trim="password"
                                dense
                                label="Password"
                                color="green"
                                :rules="[v=>!!v||'Password is required']"
                                password
                                :prepend-inner-icon="mdiLock"
                                outlined
                                autocomplete="nope"
                                :append-icon="showPassword ? mdiEye : mdiEyeOff"
                                :type="showPassword ? 'text' : 'password'"
                                @click:append="showPassword = !showPassword"
                            />
                        </div>
                        <a style="color: white;" href="/admin/recover">Forgot password?</a>
                        <br>
                        <v-btn

                            type="submit"
                            color="green accent-4"
                            width="100%"
                            height="55px"
                            class="white--text"
                            rounded
                        >
                            Sign in
                        </v-btn>
                    </v-form>
                    <br>
                    <div>Not Registered? <span @click="$router.push('/admin/register')">Signup here</span></div>
                    <br><br>
                </div>
            </div>
        </v-card>
    </div>
</template>

  <script>
import { mdiEmailOutline, mdiEye, mdiEyeOff, mdiLock } from '@mdi/js'
import { mapActions, mapGetters } from 'vuex'
export default {
    data: () => ({
        mdiEmailOutline, mdiEye, mdiEyeOff, mdiLock,
        errLogin: {
            status: false,
            message: null
        },
        email: '',
        password: '',
        showPassword: false,
        valid: true,
        emailRules: [
            v => !!v || 'Email is required',
            // v => /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(v) || "E-mail must be valid",
            v => /^[a-zA-Z0-9]+([._%-][a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/.test(v) || 'E-mail must be valid'
        ],
        screen_width: document.documentElement.clientWidth + 9
    }),
    computed: {
        ...mapGetters(['loginData'])
    },
    watch: {
        async loginData(newVal) {
            if (newVal) {
                if (newVal.status === 200) {
                    await this.getCsrfToken()
                    if (this.$cookies.get('user_type') == 'claims') {
                        this.$router.push({ name: 'ledgers' })
                    } else if (this.$cookies.get('user_type') == 'acu') {
                        this.$router.push({ name: 'acuMenu' })
                    } else {
                        this.$router.push({ name: 'providersMenu' })
                    }
                } else {
                    this.errLogin.status = true
                    this.errLogin.message = newVal.state
                    setTimeout(()=>{
                        // this.errLogin.status = false
                    }, 5000)
                }
            }
        }
    },
    mounted() {
        window.addEventListener('resize', this.onResize)
    },
    destroyed() {
        window.removeEventListener('resize', this.onResize)
    },
    methods: {
        ...mapActions(['getCsrfToken', 'login']),
        async validate() {
            if (this.$refs.form.validate()) {
                await this.login({ EMAIL: this.email, PASSWORD: this.password })
            }
        },
        onResize() {
            this.screen_width = document.documentElement.clientWidth
            // console.log('onResize: ', this.screen_width)
        }
    }
}
  </script>

  <style scoped>
  .loginWrapper {
    height: 100%;
    background-image: url("./../../../assets/loginBG.webp");
    background-position: center;
    background-size: cover;
    padding-top: 20px;
  }
  .userRole {
    /* background-color: red; */
    margin-bottom: 30px;
  }
  .login-card-wrapper {
    position: relative;
    top: 50%;
    margin: 0 auto;
    transform: translateY(-50%);
  }
  .content-wrapper {
    height: 100%;
    width: 100%;
    margin: auto;
  }
  /* Login inputs */
  .loginInputs {
    height: 100%;
    padding-bottom: 10px;
    width: 100%;
    position: relative;
  }
  .loginInputs p {
    width: 80%;
  }
  .textFields {
    width: 100%;
  }

  span {
    cursor: pointer;
    font-weight: bold;
    color: white;
  }
  .header {
    text-align: center;
  }
  .logoBg {
    width: 100%;
    border-radius: 14px 2px 0 0;
    background: linear-gradient(300deg, #52fe99, #04d68a);
  }
  .whiteCross {
    width: 100px;
    margin: 20px auto 10px auto;
  }
  .whiteCross img {
    width: 100%;
  }
  a {
    color: white;
    text-decoration: none;
    transition: all 0.5s ease;
  }
  a:hover {
    letter-spacing: 1px;
  }

  .bounce-enter-active {
    animation: bounce-in .5s;
  }
  .bounce-leave-active {
    animation: bounce-in .5s reverse;
  }
  @keyframes bounce-in {
    0% {
      transform: scale(0);
    }
    50% {
      transform: scale(1.1);
    }
    100% {
      transform: scale(1);
    }
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .25s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  @media (max-width: 599px) {
    .login-card-wrapper {
      width: 90%;
      /* height: 650px; */
    }
  }
  @media (min-width: 599px) and (max-width: 960px) {
    .login-card-wrapper {
      width: 50%;
      /* height: 625px; */
    }
  }
  @media (min-width: 960px) and (max-width: 1264px) {
    .login-card-wrapper {
      width: 40%;
      /* height: 625px; */
    }
  }
  @media (min-width: 1264px) and (max-width: 1904px) {
    .login-card-wrapper {
      width: 30%;
      /* height: 650px; */
    }
  }
  @media (min-width: 1904px) {
    .login-card-wrapper {
      width: 20%;
      /* height: 800px; */
    }
  }
  </style>
